(function() { module.exports = this["wp"]["isShallowEqual"]; }());